<div *ngIf="moreThanTwoDays || twoDaysOrLess">
  <app-imp-notice [theme]="'red'" [impText]="impNoticeTxt"></app-imp-notice>
</div>

<div *ngIf="!billedInvoice && plannedWithdrawalDate?.length && policyId.length !== 6">
  <app-attention-info
    [attentionText]="attentionInfoText"
  ></app-attention-info>
</div>

<div class="unenrolled-container">
  <ng-container *ngIf="loading">
    <mapfre-loading></mapfre-loading>
  </ng-container>

  <ng-container *ngIf="!loading">
    <div class="d-flex flex-column align-items-center">
      <div class="modal-icon-box-center">
          <img src="./assets/img/images/info-icon-acmic.svg" alt="info circle icon"/>
      </div>
      <ng-container *ngIf="company !== 'TW' && company !== 'ACIC'; else legacyContent">
        <ng-container *ngIf="outstandingBalance > 0; else noBalance">
          <div class="autopay-title">
              Your {{ policyType }} policy {{ policyId }} 
              <span class="web-line-break">is unenrolled from autopay</span>
          </div>
          <div class="autopay-sub-title">
              {{ "BILLING_SECTION_INVOICE" | translate }}
          </div>
        </ng-container>
        <ng-template #noBalance>
          <div class="autopay-title">
              Your {{ policyType }} policy {{ policyId }} is unenrolled from autopay<span *ngIf="!isAcmic">.</span>
          </div>
        </ng-template>
      </ng-container>
      <ng-template #legacyContent>
        <div class="autopay-title">
            We’ve received your {{ policyType }} policy {{ policyId }} unenrolled request
        </div>
        <div class="autopay-sub-title" *ngIf="!isUnenrollFromRecurringCCDC">
           {{ "LEGACY_EFT_PROCESS_CHANGES" | translate }}.
        </div>
         <div class="autopay-sub-title mb-4" *ngIf="isUnenrollFromRecurringCCDC">
           Check the documents tab in the billing <span class="web-line-break">section for the invoice.</span>
        </div>
      </ng-template>
    </div>  
    <div class="row">
      <div class="col">
        <ng-container *ngIf="company !== 'TW' && company !== 'ACIC'">
          <div  class="modal-info margin-bottom mb24" *ngIf="moreThanTwoDays">
            {{ "UNENROLL_DISCUSS_OPTION" | translate }}
              <a
                href="tel:{{ 'CUSTOMER_SERVICE_NUMBER' | translate }}"
                class="link-phone nowrap"
              >
                {{ "CUSTOMER_SERVICE_NUMBER" | translate }}</a>.
          </div>
          <p
            class="modal-info margin-bottom mb24"
            *ngIf="!billedInvoice"
          >
            {{ txtPara }}
          </p>
        </ng-container>
        <div class="d-flex flex-column">
          <ng-container *ngIf="billedInvoice || !plannedWithdrawalDate?.length && policyId?.length !== 6; else notBilledOrAs400">
            <mapfre-button additionalClasses="basic primary large-btn text-capitalize"                        
              (click)="openAutoPay()">
              {{ (company === 'TW' || company === 'ACIC') ? "Continue" : "Ok" }}
            </mapfre-button>            
          </ng-container>
          <ng-template #notBilledOrAs400>
            <mapfre-button additionalClasses="basic primary large-btn pay-now"
              (click)="payNow($event)">
              {{ "PAY_NOW" | translate }}
            </mapfre-button>
            <mapfre-button 
              (click)="openAutoPay()"
              additionalClasses="link-button small-btn autopay-not-now"
              [backIcon]="backIcon"
              [iconClasses]="'align-middle'" 
              [showIconsCustom]="true">
              {{ "Not now" | translate }}
            </mapfre-button>
          </ng-template>
        
        </div>
      </div>
    </div>
  </ng-container>
</div> 
